<template>
    <div id="idNavierasTipoRecargo">
        <ui-modal 
            :title="'Asociar Código a Naviera // ' + typeCode "
            size="large" 
            ref="modal" 
            @close="actionsSetShowModalRechargesNavieras(false)"
        >
            
            <div class="container-fluid" >
                <div class="row w-100 mt-2">
                    <div class="col-4">
                        <ui-select 
                            class="w-100" 
                            label="Cotizaciones" 
                            placeholder="Seleccione"
                            :keys="{ value: 'id', label: 'name' }"
                            :options="quotationNavierasList"
                            has-search
                            @change="getCodesRechargesTypes( quotation_naviera.id, id );"
                            searchPlaceholder="Buscar"
                            v-model="quotation_naviera"
                        />
                        
                    </div>
                    <div class="col-4">
                        <ui-textbox 
                            class="w-100" 
                            label="Código" 
                            v-model="code"
                            type="text"
                        />
                    </div>

                    <div class="col-4">
                        <div class="w-50">
                            <Button
                                :size="15"
                                color="#2da44e"
                                colorText="#ffffff"
                                tooltip="Agregar Código"
                                icon="fas fa-plus"
                                class="mt-3"
                                round
                                :width="30"
                                :inactive="btnStatus"
                                @click.native=" !btnStatus && send()"
                                traslate
                            />
                        </div>
                       
                    </div>
                </div>
                <div class="row w-100 mt-2">
                    <div class="col">
                        <h4 class="float-left" > Códigos Navieras</h4>
                    </div>
                </div>
                <div v-if="!load" class="row w-100">
                    <div class="col">
                        <div class="w-100 text-center">
                            <new-data-table
                                customHeaders
                                :headers="headers"
                                :data="data"
                                :acciones="acciones"
                                :max="10"
                                paginacion
                                idtabla="listado_tipos_recargos_navieras"
                                :seleccionar="obtenerFilaSeleccionada"
                            />
                        </div>
                        
                    </div>
                </div>
                <div v-else class="row w-100 mt-2">
                    <div class="col">
                        <loading />
                    </div>
                </div>
                <div  class="row w-100 mt-2">
                    <div class="col">
                        <div class="w-100 d-flex justify-content-end">
                            <button class="btn btn-default" @click="cerrarModal" >Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        </ui-modal>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { deleteRechargeTypeNaviera, getQuotationNavieras, getTariffRechargeAddCodeNaviera, getTariffRechargeCodeNaviera } from '../../../../../constants/lineas';
import Button from '../../../../common/Button.vue';
import Loading from '../../../../common/loading.vue';
import NewDataTable from '../../../../common/NewDataTable.vue';

export default {
    data() {
        return {
            code : "",
            quotation_naviera : {},
            btnStatus: false,
            typeCode : "",
            data : [],
            headers: [
                { title: "Código Naviera", width: "127px" },
                { title: "Naviera", width: "127px" },
                { title: "Acciones", width: "118px"  }
            ],
            acciones : [],
            load : false,
            quotationNavierasList: []
        };
    },
    props: {
        id : { type: Number  , default: null },

    },

    components: {Button, NewDataTable, Loading},

    created() {

    },

    mounted() {
        this.getQuationNavierasData();

    },

    methods: {

        ...mapActions(["ActionSetZindexTablaModal"]),

        ...mapActions("lineas", [
            "actionsSetShowModalRechargesNavieras"
        ]),

        openModal(ref) {
            this.ActionSetZindexTablaModal(true);
            this.$refs[ref].open();
        },
        closeModal(ref) {
            this.$refs[ref].close();
        },
        cerrarModal(){
            this.closeModal("modal");
            this.ActionSetZindexTablaModal(false); 
        },
        generarBotonesAcciones() {
            let me = this;
            me.acciones = [];

            me.data.map((item, index) => {
                me.acciones.push([{
                    icon: "fa fa-trash text-danger zoom",
                    title: "Eliminar",
                    id: index,
                }]);
            });
        },
        async obtenerFilaSeleccionada( { accion ,id } ){
            
            switch (accion) {
                case "Eliminar": {

                    const code = this.data[ id ].data_complementaria.code ;

                    const response = await this.$vToastify.prompt(`¿Está seguro que desea eliminar ${ code } ?`) ;

                    if( ! response ) return ;

                    const idRechargeTypeNaviera = +this.data[ id ].data_complementaria.id ;

                    try {

                        this.$vToastify.loader("Eliminando...");

                        await deleteRechargeTypeNaviera( idRechargeTypeNaviera );
                        
                        this.$vToastify.stopLoader();

                        await this.getCodesRechargesTypes( this.quotation_naviera.id, this.id );

                        return this.$vToastify.success("Se eliminó código correctamente", "Éxito");

                    } catch (error) {
                        
                        this.$vToastify.stopLoader();

                        return this.$vToastify.error(
                            "Error al eliminar un código. Favor, recargar la página y vuelva a intentar.",
                            "Error"
                        );

                    };
                }
                
            }
        },
        valid(){
            
            if( ! this.code )  {
                this.$vToastify.warning(
                    "Campo 'Código' requerido",
                    "Error"
                );    
                return false ;
            }

            if( ! this.quotation_naviera.id )  {
                this.$vToastify.warning(
                    "Campo 'Cotizaciones' requerido",
                    "Error"
                );    
                return false ;
            }

            return true ;
        },
        resetForm(){
            this.code = "" ;
            //this.quotation_naviera = {} ;
        },
        async getCodesRechargesTypes( id , idRechargeType ){

            this.load = true ;

            const { data } = await getTariffRechargeCodeNaviera( id , idRechargeType );

            this.typeCode = data.length > 0 ? data[0].type_code : "" ;

            this.data = data.map( d => ({
                data : [ d.code , d.naviera_name ],
                data_complementaria : d
            })) ;

            this.load = false ;
        },
        async getQuationNavierasData() {

            const { data } = await getQuotationNavieras();

            this.quotationNavierasList = data ;
            
        },
        async send(){

            if( ! this.valid() ) return ;

            const form = {
                id_tariff_recharges_types_navieras_code : + this.quotation_naviera.id,
                code : this.code.toString(),
                id_recharges_types : + this.id
            } ;

            this.btnStatus = true ;
            this.$vToastify.loader("Agregando Código...");

            try {
                await getTariffRechargeAddCodeNaviera( form );

                this.$vToastify.stopLoader();
                this.btnStatus = false ;

                this.getCodesRechargesTypes( this.quotation_naviera.id, this.id );
                this.resetForm() ;

                return this.$vToastify.success("Se agrego Código", "Éxito");

            } catch (error) {
                this.$vToastify.stopLoader();

                this.btnStatus = false ;
                return this.$vToastify.error(
                    "Error al agregar un código. Favor, recargar la página y vuelva a intentar.",
                    "Error"
                );
            };
        }
    },

    computed: {
        ...mapState("lineas", ["showModalRechargesNavieras"]),

        ...mapState([ "navieras" ]),    
    },

    watch: {
        showModalRechargesNavieras : function( _new ){

            if( _new ) return this.openModal("modal") ;

            this.code = "" ;
            this.data = [] ;
            this.typeCode = "" ;
            this.quotation_naviera = {} ;

            this.cerrarModal();
        },
        data : function( ){
            this.generarBotonesAcciones();
        },

    },
};
</script>
